import { ScrapedCategoryFilters } from "@/types/scrape-category";

export const SCRAPE_CATEGORY_KEY = "SCRAPE_CATEGORY";

export const SCRAPE_CATEGORY_CACHE_KEY = {
  LIST: (filters: ScrapedCategoryFilters) =>
    [SCRAPE_CATEGORY_KEY, "LIST", filters] as const,
  DETAIL: (id: string) => [SCRAPE_CATEGORY_KEY, "DETAIL", id] as const,
};
